export const iconFontAwesomeBuildingsMosque = (
	<i className="fa-solid fa-mosque"></i>
);
